<div class="container">
  <div class="mb-2 title">Vos programmes 3e-etage</div>
  <div class="separator2 mb-6"></div>
  @if(isLoading) {
  <div>Chargement en cours...</div>
  } @else if(programs.length === 0) {
  <div>Aucun programme disponible</div>
  } @for(program of programs; track program.id){
  <div class="program mb-2">
    <div [routerLink]="'/program/' + program.id" class="cursor-pointer" title="Voir le programme">
      <div class="uppercase font-bold">{{ program.name }}</div>
      <div>{{ program.date }}</div>
    </div>
  </div>
  }

  <div (click)="signOut()" class="cursor-pointer mt-8 font-italic underline">Me déconnecter</div>
</div>
